import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IBtn, IFpxShell, IShellButtonAction } from '../models/index';

/** View shell */
@Injectable({
  providedIn: 'root',
})
export class FpxViewShellService implements IFpxShell {
  formGroup!: FormGroup<any>;
  onBtnClick = (action: keyof IShellButtonAction) => {};

  doPreInit(): void {
    throw new Error('Method not implemented.');
  }

  btnList: IBtn[] = [];

  _setFormGroup(form: FormGroup) {
    this.formGroup = form;
    this.loadDependencies();
  }

  loadDependencies() {
    this.btnList = [
      {
        label: 'Back',
        buttonClass: 'btn-primary',
        buttonType: 'button',
        buttonAction: 'onBack',
      },
    ];
  }
}
